import { render } from "./TakeAwayPageHeader.vue?vue&type=template&id=4e129d7f"
import script from "./TakeAwayPageHeader.vue?vue&type=script&lang=js"
export * from "./TakeAwayPageHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__